window.supportsPassive = false

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function () {
      window.supportsPassive = true
    }
  })
  window.addEventListener('test', null, opts)
} catch (e) {}

function globalTouchHandler (e) {
  e.preventDefault()
}

export default class ScrollLocker {
  constructor (el) {
    this.el = el
    this.calcRect()
    this._onTouchStart = this._onTouchStart.bind(this)
    this._onTouchMove = this._onTouchMove.bind(this)
    this.el.addEventListener('touchstart', this._onTouchStart, true)
    this.el.addEventListener('touchmove', this._onTouchMove, true)
  }

  calcRect () {
    this.scrollHeight = this.el.scrollHeight
    this.offsetHeight = this.el.offsetHeight

    this.locked = this.scrollHeight === this.offsetHeight
  }

  _onTouchStart (e) {
    this.lastY = e.touches[0].pageY
  }

  _onTouchMove (e) {
    e.stopPropagation()
    if (this.locked) {
      e.preventDefault()
      return false
    }
    const scrollTop = this.el.scrollTop
    const touch = e.touches[0]
    const currY = touch.pageY
    const direction = currY - this.lastY

    if (scrollTop === 0 && direction > 0) {
      e.preventDefault()
    } else if (this.scrollHeight <= this.offsetHeight + scrollTop && direction < 0) {
      e.preventDefault()
    }
    this.lastY = currY
  }

  unlock () {
    this.el.removeEventListener('touchstart', this._onTouchStart, true)
    this.el.removeEventListener('touchmove', this._onTouchMove, true)
  }

  static lock (el) {
    let lockerId = el.dataset && el.dataset.lockerId ? el.dataset.lockerId : ''
    if (lockerId) {
      this.unlock(el)
    } else {
      lockerId = el.dataset.lockerId = this.genLockerId()
    }
    if (!size(this.lockers)) {
      document.addEventListener('touchmove', globalTouchHandler, window.supportsPassive ? {
        passive: false
      } : false)
    }
    const lockers = this.lockers[lockerId] = [];

    [...el.querySelectorAll('[data-skip-locker]')].forEach(v => {
      lockers.push(new ScrollLocker(v))
    })

    return lockerId
  }

  static unlock (el) {
    let lockerId = el.dataset && el.dataset.lockerId ? el.dataset.lockerId : ''

    if (!lockerId) {
      return
    }

    let lockers = this.lockers[lockerId]
    delete this.lockers[lockerId]
    if (Array.isArray(lockers)) {
      lockers.forEach(v => v.unlock())
    }

    if (!size(this.lockers)) {
      document.removeEventListener('touchmove', globalTouchHandler, window.supportsPassive ? {
        passive: false
      } : false)
    }
  }

  static genLockerId () {
    return `locker_${++this.SEQ}`
  }
}

function size (obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      return true
    }
  }
  return false
}

ScrollLocker.lockers = {}
ScrollLocker.SEQ = 0
